import { HttpError } from '@refinedev/core';
import { ResponseError } from 'interfaces/api-error';

export const ReportKindMap = {
  graduate_enrollment_academic_record: 'Histórico escolar',
  student_graduate_course_certificate: 'Certificado',
  student_graduate_enrollment_statement: 'Declaração de matrícula',
  student_graduate_course_finished: 'Declaração de conclusão de curso'
} as const;

export const CERTIFICATE_REPORT_KIND = 'student_graduate_course_certificate';

export const UNIQUE_SIGNATURE_PARTNER_REPORT_KINDS = [
  'graduate_enrollment_academic_record',
  'student_graduate_enrollment_statement',
  'student_graduate_course_finished'
] as const;

export type SignaturePartnerReportKind = keyof typeof ReportKindMap;

export const signaturePartnerReportKindOptions = (
  Object.entries(ReportKindMap) as [SignaturePartnerReportKind, string][]
).map(([value, label]) => ({ value, label }));

export const SIGNATURE_PARTNER_ALREADY_EXISTS_ERROR =
  'certifiers_signature_partners_already_signature_error';

export const signaturePartnerErrorNotification = (
  error: HttpError | undefined,
  fallbackMessage: string
) => {
  const err = error as unknown as ResponseError;

  if (
    typeof err === 'object' &&
    err !== null &&
    err.code === SIGNATURE_PARTNER_ALREADY_EXISTS_ERROR
  ) {
    return {
      type: 'error' as const,
      description: 'Assinatura duplicada',
      message:
        'Não é possível ter mais de um modelo de assinatura para este local. Edite o cadastro existente se precisar alterá-lo.'
    };
  }

  return {
    type: 'error' as const,
    description: 'Ops!',
    message: fallbackMessage
  };
};
